import { Link } from 'react-router-dom';

const tentes = [
  { title: 'Kasetli Tente', href: '/hizmetler/kasetli-tente', img: '/images/kasetli-tente/hero.webp' },
  { title: 'Körüklü Tente', href: '/hizmetler/koruklu-tente', img: '/images/koruklu-tente/hero.webp' },
  { title: 'Mafsallı Tente', href: '/hizmetler/mafsalli-tente', img: '/images/mafsalli-tente/hero.webp' },
  { title: 'T Model Tente', href: '/hizmetler/t-model-tente', img: '/images/t-model-tente/hero.webp' },
  { title: 'Win Tente', href: '/hizmetler/win-tente', img: '/images/win-tente/hero.webp' },
];

const pergolas = [
  { title: 'Bioklimatik Pergola', href: '/hizmetler/bioklimatik-pergola', img: '/images/bioklimatik-pergola/hero.webp' },
  { title: 'Otomatik Pergola', href: '/hizmetler/otomatik-pergola', img: '/images/otomatik-pergola/hero.webp' },
  { title: 'Rollingroof Pergola', href: '/hizmetler/rollingroof-pergola', img: '/images/rollingroof-pergola/hero.webp' },
];

const brandas = [
  { title: 'Şeffaf Branda', href: '/hizmetler/seffaf-branda', img: '/images/seffaf-branda/hero.webp' },
  { title: 'Şeffaf Stor Branda', href: '/hizmetler/seffaf-stor-branda', img: '/images/seffaf-stor-branda/hero.webp' },
  { title: 'Zip Perde', href: '/hizmetler/zip-perde', img: '/images/zip-perde/hero.webp' },
];

interface ServiceCardProps {
  title: string;
  href: string;
  img: string;
  size?: 'normal' | 'large';
}

function ServiceCard({ title, href, img, size = 'normal' }: ServiceCardProps) {
  return (
    <Link
      to={href}
      className="group relative overflow-hidden block cursor-pointer"
      style={{ height: size === 'large' ? '320px' : '220px' }}
    >
      <img
        src={img}
        srcSet={`${img.replace('.webp', '-480.webp')} 480w, ${img} 1200w`}
        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 280px"
        alt={`${title} Alaçatı`}
        width={1200}
        height={896}
        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
        loading="lazy"
        decoding="async"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#111827] via-[#111827]/20 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-5 flex items-end justify-between">
        <div>
          <h3 className="text-white font-black text-base leading-tight">{title}</h3>
          <p className="text-[#D4A853] text-xs font-semibold tracking-wider uppercase mt-1">Alaçatı</p>
        </div>
        <div className="w-9 h-9 flex items-center justify-center bg-[#D4A853] opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
          <i className="ri-arrow-right-line text-[#111827] text-base"></i>
        </div>
      </div>
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#D4A853] scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
    </Link>
  );
}

export default function ServicesSection() {
  return (
    <section className="py-24 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="w-8 h-px bg-[#D4A853]"></span>
              <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Tente · Pergola · Branda</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-[#111827] leading-tight">
              Hizmetlerimiz
            </h2>
          </div>
          <Link
            to="/hizmetler"
            className="flex items-center gap-2 border-2 border-[#111827] text-[#111827] hover:bg-[#111827] hover:text-white font-bold text-xs tracking-widest uppercase px-6 py-3 transition-all whitespace-nowrap cursor-pointer self-start md:self-auto"
          >
            Tüm Hizmetler
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Tente Sistemleri */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <h3 className="text-xs font-black tracking-widest uppercase text-[#111827]">Tente Sistemleri</h3>
            <span className="flex-1 h-px bg-[#E8E0D0]"></span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {tentes.map((s) => (
              <ServiceCard key={s.href} {...s} />
            ))}
          </div>
        </div>

        {/* Pergola Sistemleri */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <h3 className="text-xs font-black tracking-widest uppercase text-[#111827]">Pergola Sistemleri</h3>
            <span className="flex-1 h-px bg-[#E8E0D0]"></span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {pergolas.map((s) => (
              <ServiceCard key={s.href} {...s} size="large" />
            ))}
          </div>
        </div>

        {/* Branda & Perde */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <h3 className="text-xs font-black tracking-widest uppercase text-[#111827]">Branda &amp; Perde Sistemleri</h3>
            <span className="flex-1 h-px bg-[#E8E0D0]"></span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {brandas.map((s) => (
              <ServiceCard key={s.href} {...s} size="large" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
